import React from "react";
import BottomBannerArrowImg from '../../img/arrow-banner-bottom.png';

export const BottomBannerArrow = (props) => {
    return (
        <>
            <img src={BottomBannerArrowImg} />
        </>
    )
}